// External libs
import { createAction } from '@reduxjs/toolkit'

const closeAction = createAction('singleStoreDropDialog/close')

const clearAction = createAction('singleStoreDropDialog/clear')

const maximizeAction = createAction('singleStoreDropDialog/maximize')

const openAction = createAction('singleStoreDropDialog/open')

const clear = () => (dispatch: any) => {
  dispatch(clearAction())
}

const close = () => (dispatch: any) => {
  dispatch(closeAction())
}

const maximize = () => (dispatch: any) => dispatch(maximizeAction())

const open = () => (dispatch: any) => {
  dispatch(openAction())
}
const actions = {
  clear,
  clearAction,
  close,
  closeAction,
  maximize,
  maximizeAction,
  open,
  openAction,
}

export default actions
